import { render, staticRenderFns } from "./DeveloperName.vue?vue&type=template&id=4698335f&"
import script from "./DeveloperName.vue?vue&type=script&lang=ts&"
export * from "./DeveloperName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports